import { createContext, useContext } from 'react';

export const ProgramConfigStateContext = createContext();
export const ProgramConfigDispatchContext = createContext();

export const useProgramConfigStateContext = () => useContext(ProgramConfigStateContext);
export const useProgramConfigDispatchContext = () => useContext(ProgramConfigDispatchContext);
